import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const caTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nom (en minúscules, sense caràcters especials)',
    add: 'Afegeix',
    allowedFileTypes: 'Tipus de fitxers permesos',
    allowedFileTypesDescription:
      'Restringeix els tipus de fitxer permesos (p. ex., imatge/*, aplicació/pdf). Deixeu-lo en blanc per permetre tot tipus.',
    allowMultipleFiles: 'Permet diversos fitxers',
    amountInCents: 'Import en cèntims',
    basePrice: 'Preu base',
    bcc: 'BCC',
    brand: 'Marca',
    cc: 'CC',
    checkboxPlural: 'Camps de casella de selecció',
    checkboxSingular: 'casella de selecció',
    checkedByDefault: 'Marcat per defecte',
    chooseConfirmationType:
      "Trieu si voleu mostrar un missatge a la pàgina o redirigir a una pàgina diferent després d'enviar el formulari.",
    condition: 'Condició',
    confirmationMessage: 'Missatge de confirmació',
    confirmationType: 'Tipus de confirmació',
    countryPlural: 'Camps del País',
    countrySingular: 'País',
    creditCard: 'Targeta de crèdit',
    customURL: 'URL personalitzat',
    datePlural: 'Camps de data',
    dateSingular: 'Data',
    defaultValue: 'Valor per defecte',
    divide: 'Divideix',
    documentToLinkTo: 'Document per enllaçar',
    doesNotEqual: 'No és igual',
    emailFrom: 'Correu electrònic de',
    emailPlural: 'Camps de correu electrònic',
    emailsDescription:
      "Envieu correus electrònics personalitzats quan s'enviï el formulari. Utilitzeu llistes separades per comes per enviar el mateix correu electrònic a diversos destinataris. Per fer referència a un valor d'aquest formulari, emboliqueu el nom d'aquest camp amb claudàtors dobles, és a dir, {{firstName}}. Podeu utilitzar un comodí {{*}} per generar totes les dades i {{*:table}} per formatar-lo al correu electrònic com a taula HTML.",
    emailSingular: 'Correu electrònic',
    emailTo: 'Correu electrònic a',
    equals: 'Iguals',
    field: 'Camp',
    fields: 'Camps',
    fieldWidth: 'Amplada del camp (percentatge)',
    hasAnyValue: 'Té qualsevol valor',
    internalLink: 'Enllaç intern',
    label: 'Etiqueta',
    maxFileSize: 'Mida màxima del fitxer (bytes)',
    maxFileSizeDescription: 'Mida màxima del fitxer en bytes. Deixeu buit sense límit.',
    message: 'Missatge',
    messageDescription: "Introduïu el missatge que s'ha d'enviar en aquest correu electrònic.",
    messagePlural: 'Blocs de missatges',
    messageSingular: 'Missatge',
    mimeType: 'Tipus MIME',
    mimeTypePlural: 'Tipus MIME',
    mimeTypeSingular: 'Tipus MIME',
    multiply: 'Multiplicar',
    numberPlural: 'Camps numèrics',
    numberSingular: 'Número',
    optionPlural: 'Opcions',
    optionSingular: 'Opció',
    paymentFieldPlural: 'Camps de pagament',
    paymentFieldSingular: 'Pagament',
    paymentProcessor: 'Processador de pagaments',
    paymentStatus: 'Estat',
    placeholder: 'Marcador de posició',
    priceConditions: 'Condicions de preu',
    priceConditionsPlural: 'Condicions de preu',
    priceConditionsSingular: 'Condició de preu',
    radioOptions: "Opcions d'atributs de ràdio",
    radioPlural: 'Camps de ràdio',
    radioSingular: 'Ràdio',
    redirect: 'Redirigeix',
    replyTo: 'Respon a',
    required: 'Obligatori',
    selectOptions: 'Seleccioneu Opcions',
    selectPlural: 'Seleccioneu Camps',
    selectSingular: 'Seleccioneu',
    statePlural: 'Camps estatals',
    stateSingular: 'Estat',
    staticValue: 'Valor estàtic',
    subject: 'Assumpte',
    submitButton: "Envia l'etiqueta del botó",
    subtract: 'Resta',
    textareaPlural: "Camps d'àrea de text",
    textareaSingular: 'Àrea de text',
    textPlural: 'Camps de text',
    textSingular: 'Text',
    title: 'Títol',
    token: 'testimoni',
    uploadCollection: 'Carrega la col·lecció',
    uploadCollectionDescription:
      'Seleccioneu quina col·lecció de càrrega per emmagatzemar els fitxers',
    uploadFieldPlural: 'Carrega camps',
    uploadFieldSingular: 'Carrega',
    urlToRedirectTo: 'URL per redirigir',
    value: 'Valor',
    valueOfField: 'Valor del camp',
    valueType: 'Tipus de valor',
  },
}

export const ca: PluginLanguage = {
  dateFNSKey: 'ca',
  translations: caTranslations,
}
